import { Observable } from 'rxjs/Rx';
import { Injectable, Component } from '@angular/core';
import { Http, Response, RequestOptionsArgs, Headers, RequestOptions } from '@angular/http';
import { LocalStorageService } from 'ng2-webstorage';
import { HttpHeaders } from '@angular/common/http';


@Injectable()
export class HttpClient {
    public xaccesstoken: string;
    constructor(private http: Http,
        private localStorage: LocalStorageService
    ) {

    }
    getHeaders(isAuthRequired: boolean): RequestOptions {
        this.xaccesstoken = this.localStorage.retrieve('authToken');

        let headers = new Headers({ 'Content-Type': 'application/json' });
        if (isAuthRequired) {
            headers.append('authToken', this.xaccesstoken);
        }
        return new RequestOptions({
            headers: headers,
        });
    }
    Get(url: string, isAuthRequired: boolean = true, options?: RequestOptionsArgs): Observable<Response> {
        if (navigator.onLine) {
            //  let newOptions = this.getHeaders(isAuthRequired);
            //return this.http.get(url, Object.assign({}, options, newOptions));
            return this.http.get(url, Object.assign({}, options));
        } else {
            console.log('offline');

        }

    }





  Post(url: string, body: any, isAuthRequired: boolean = true, options?: RequestOptionsArgs): Observable<Response> {
        // let headers = new Headers({ 'Content-Type': 'application/json' });
        //let newOptions = this.getHeaders(isAuthRequired);
        //return this.http.post(url, body, Object.assign({}, options, newOptions));
        return this.http.post(url, body, Object.assign({}, options));
    }


  FormPostBlob(url: string, isAuthRequired: boolean = true, options?: RequestOptionsArgs): Observable<Blob> {
    const headers = new Headers({
      'Accept': '*/*'
    });
    if (isAuthRequired) {
      const authToken = this.localStorage.retrieve('authToken');
      headers.append('authToken', authToken);
    }
    const newOptions: RequestOptionsArgs = {
      headers: headers,
      responseType: 3 // ResponseContentType.Blob
    };
    return this.http.post(url, null, Object.assign({}, options, newOptions))
      .map((response: Response) => response.blob());
  }



  FormPost(url: string, body: any, isAuthRequired: boolean = true, options?: RequestOptionsArgs): Observable<Response> {
        let newOptions = this.getHeaders(isAuthRequired);
        return this.http.post(url, body, Object.assign({}, options, newOptions));
    }


    PostFormDataOld(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
      const formData: FormData = new FormData();
      for (const key in body) {
        if (body.hasOwnProperty(key)) {
          formData.append(key, body[key]);
        }
      }

      // Don't set headers for FormData, let the browser handle it
      return this.http.post(url, formData);
    }


  PostPDFDataOld(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    let formData: FormData = new FormData();
    for (var key in body) {
      formData.append(key, body[key]);
    }
    let headers = new Headers(
      { 'Content-Type': false, 'mimeType': 'multipart/form-data', 'data': 'form', },
    );
    return this.http.post(url, formData, Object.assign({}, options));
  }

    PostMultipart(url: string, body: any, options?: any): Observable<any> {
        const formData: FormData = new FormData();

        for (let key in body) {
            if (body[key] instanceof File) {
              formData.append(key, body[key], body[key].name);
            } else {
              // console.log(key);
              // console.log(body[key]);
                formData.append(key, body[key]);
            }
        }

        const headers = new HttpHeaders().set('mimeType', 'multipart/form-data');

        return this.http.post(url, formData, { ...options, headers });
    }

    PostFormData(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
        let formData: FormData = new FormData();
        formData.append('', body);
        return this.http.post(url, formData, Object.assign({}, options));
    }


    Put(url: string, body: any, isAuthRequired: boolean = true, options?: RequestOptionsArgs): Observable<Response> {
        let newOptions = this.getHeaders(isAuthRequired);
        return this.http.put(url, body, Object.assign({}, options, newOptions));
    }

    Putt(url: string, body: any, isAuthRequired: boolean = true, options?: RequestOptionsArgs): Observable<Response> {
        // let newOptions = this.getHeaders(isAuthRequired);
        return this.http.put(url, body, Object.assign({}, options));
    }

    Delete(url: string, isAuthRequired: boolean = true, options?: RequestOptionsArgs): Observable<Response> {
        // let newOptions = this.getHeaders(isAuthRequired);
        return this.http.delete(url, Object.assign({}, options));
    }



}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/services/http.service.ts